import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import DataGrid, { Column, FilterRow, HeaderFilter, Paging, Pager, Scrolling } from 'devextreme-react/data-grid'
/* API LIST */
import { getBomiDeliveryStatus } from '../../api/bomi'
/* CUSTOM HOOKS */
import useAlert from '../../lib/useAlert'

const DeliveryBomiStatus = (props) => {
  const { t } = useTranslation()
  const { openAlert } = useAlert()
  const [values, setValues] = useState([])

  const refGrid = useRef()

  const getDeliveryBomiStatus = async () => {
    try {
      const { data, status } = await getBomiDeliveryStatus({ sap_delivery_number: props.sapDeliveryNumber })
      if (data && status === 200 && data.P_RESULT_CODE === 0) {
        setValues(data.RESULT)
      } else {
        openAlert('error', true, data.P_RESULT_MESSAGE)
      }
    } catch (error) {
      openAlert('error', true, error.message)
    }
  }

  const cbGetDeliveryBomiStatus = useCallback(getDeliveryBomiStatus, [])

  useEffect(() => {
    cbGetDeliveryBomiStatus()
  }, [cbGetDeliveryBomiStatus])

  return (
    <DataGrid
      ref={refGrid}
      dataSource={values}
      allowColumnReordering
      showBorders
      selection={{ mode: 'single' }}
      hoverStateEnabled
      keyExpr='id'
      showRowLines
      columnAutoWidth
      rowAlternationEnabled
      focusedRowEnabled
      width='100%'
      onContentReady={(e) => {
        e.component.option('height', document.getElementById('bomi_status_dialog').clientHeight)
      }}
      allowColumnResizing
      columnResizingMode='widget'
    >
      <FilterRow visible />
      <HeaderFilter searchMode="contains" visible allowSearch />
      <Paging enabled={false} defaultPageSize={20} />
      <Pager
        showPageSizeSelector
        allowedPageSizes={[20, 50, 100]}
        showNavigationButtons
        showInfo
        infoText={t('pager_info_text')}
        visible={false}
      />
      <Scrolling mode='standart' />
      <Column dataField='date' dataType='date' caption={t('date')} format='dd.MM.yyyy HH:ss' width={120} alignment='center' />
      <Column dataField='sap_delivery_number' caption={t('sap_delivery_number')} width={120} alignment='center' />
      <Column dataField='desc' caption={t('description')} width={150} />
      <Column dataField='rem' caption={t('receiver_name')} width={180} />
      <Column dataField='bokdate' dataType='date' caption={t('booking_date')} format='dd.MM.yyyy' width={120} alignment='center' />
      <Column dataField='note' caption={t('note')} />
    </DataGrid>
  )
}

export default DeliveryBomiStatus
